import type { paths } from "@/api-schema";

export const VEHICLE_VALUATION_COST_WARRANTY_RESOURCE = "vehicle-valuation-cost-warranty" as const;
export const VEHICLE_VALUATION_COST_WARRANTY_API_PATH = `/v1/${VEHICLE_VALUATION_COST_WARRANTY_RESOURCE}` as const;
export const VEHICLE_VALUATION_COST_WARRANTY_SEARCH_OPERATION = "search" as const;
export const VEHICLE_VALUATION_COST_WARRANTY_SEARCH_API_PATH =
  `${VEHICLE_VALUATION_COST_WARRANTY_API_PATH}/${VEHICLE_VALUATION_COST_WARRANTY_SEARCH_OPERATION}` as const;

export type VehicleValuationCostWarrantyCreateBody =
  paths[typeof VEHICLE_VALUATION_COST_WARRANTY_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export type VehicleValuationCostWarrantyCreateResponse =
  paths[typeof VEHICLE_VALUATION_COST_WARRANTY_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export type VehicleValuationCostWarrantyUpdateBody =
  paths["/v1/vehicle-valuation-cost-warranty/{uuid}"]["patch"]["requestBody"]["content"]["application/json"];

export type VehicleValuationCostWarrantyUpdateResponse =
  paths["/v1/vehicle-valuation-cost-warranty/{uuid}"]["patch"]["responses"][200]["content"]["application/json"];

export type VehicleValuationCostWarrantySearchBody =
  paths[typeof VEHICLE_VALUATION_COST_WARRANTY_SEARCH_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export type VehicleValuationCostWarrantySearchParameters =
  paths[typeof VEHICLE_VALUATION_COST_WARRANTY_SEARCH_API_PATH]["post"]["parameters"]["query"];

export type VehicleValuationCostWarranty =
  paths["/v1/vehicle-valuation-cost-warranty/{uuid}"]["get"]["responses"][200]["content"]["application/json"];

export type VehicleValuationCostWarrantySearchResponse =
  paths[typeof VEHICLE_VALUATION_COST_WARRANTY_SEARCH_API_PATH]["post"]["responses"][200]["content"]["application/json"];
